import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
import ColorInternarStatus from "@/components/functionals/ColorInternarStatus";
import ColorType from "@/components/functionals/ColorType";

export default [
  {
    prop: "Id",
    name: "NO",
    label: "NO",
    width: 100,
    sortable: true,
    align: "center",
    formatter: SLAClolorStatus
  },
  {
    prop: "CustomerName",
    name: "Cliente",
    label: "Cliente",
    minWidth: 300
    /*formatter: row => {
      if (row.CustomerName === null && row.Customer !== null) {
        return row.Customer.Name;
      }
      return row.CustomerName;
    }*/
  },
  /*
  {
    name: "Clasificacion",
    label: "Clasificación",
    prop: "Customer.Clasification",
    width: 130,
    sortable: true
    //formatter: row => (row.Customer ? row.Customer.Clasification : "")
  },
  */
  /*
  {
    prop: "ServiceRequestType.Description",
    name: "Solictud",
    label: "Solictud",
    sortable: true,
    //    formatter: row => {
    //return row.ServiceRequestType ? row.ServiceRequestType.Description : "";
    //},
    minWidth: 200
  },*/
  {
    prop: "StatusDescription",
    name: "Estado",
    label: "Estado",
    sortable: true,
    minWidth: 100
  },
  {
    prop: "DeviceQuantity",
    name: "Cantidad",
    label: "Cantidad",
    width: 110,
    align: "center",
    sortable: true
    //formatter: row =>
    //row.DeviceQuantity ?? row.DeviceQuantity > 1 ? row.DeviceQuantity : ""
  },
  {
    prop: "ServiceRequestTypeDescription",
    name: "Servicio",
    label: "Servicio",
    minWidth: 200,
    sortable: true
  },
  {
    prop: "Comments",
    name: "Descripcion",
    label: "Descripción",
    minWidth: 400,
    sortable: true
  },
  {
    prop: "SLAHoursToRespond",
    name: "SLA",
    label: "SLA",
    minWidth: 75,
    align: "center",
    sortable: true
    //formatter: row => (row.SLAHoursToRespond ? row.SLAHoursToRespond : "")
  },
  {
    prop: "StatusSolicitud",
    name: "Cumplimiento",
    label: "Cumplimiento",
    sortable: true,
    align: "center",
    minWidth: 170,
    formatter: ColorInternarStatus
  },
  {
    prop: "DiasRetraso",
    name: "DiasRetraso",
    label: "Dias Retrasada",
    minWidth: 150,
    align: "center",
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "AssignedTechnicianName",
    name: "Tecnico",
    label: "Técnico",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "AssignedTechnician.ImageUrl"
    }
  },
  {
    prop: "RequestDate",
    name: "Creado",
    label: "Creado",
    formatter: DatetimeFormatter,
    minWidth: 130,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  },
  {
    prop: "DueDate",
    name: "Limite",
    label: "Limite",
    formatter: DatetimeFormatter,
    minWidth: 130,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  }
  /*
  {
    prop: "CloseDate",
    name: "Fecha Cierre",
    label: "Fecha Cierre",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  },
  */
];
